module.exports = __webpack_public_path__ + "static/media/welcomeDemo1.db8ecc72.png";